/* ============================================================================
 * sio-gift.js  —  Dislicores · Obsequios automaticos en el carrito
 * ----------------------------------------------------------------------------
 * Lee las reglas de obsequio (metacampo sio.gift_rules, publicado por
 * sio:sync-pdp-discounts) en el momento de conciliar —desde window.SIO_GIFT_RULES
 * o desde #sio-gift-rules del embed— y mantiene en el carrito la cantidad que
 * corresponda. Una regla puede dispararse por producto, marca o categoria; por
 * monto de carrito; por cada N unidades; o por combo de dos grupos.
 *
 * REPARTO DE RESPONSABILIDADES (esto es lo importante)
 *
 * Hay dos actores y cada uno manda en lo suyo:
 *
 *   - Este script decide si AGREGAR una linea de obsequio. Es una estimacion.
 *   - La funcion de descuentos del servidor decide si la DEJA EN CERO. Es la
 *     autoridad, porque es la que de verdad cobra.
 *
 * Todos los defectos de esta pieza vinieron de que el script intentara ganarle
 * la discusion al servidor: si el script insistia en que el obsequio corresponde
 * y el servidor no lo ponia gratis, quedaba una linea COBRADA en el carrito.
 *
 * Por eso la regla es: para agregar manda la estimacion; para CONSERVAR manda el
 * servidor. Si una linea de obsequio nuestra no esta en cero, se retira. Punto.
 * Asi las dos partes nunca se pelean y el sistema converge solo.
 *
 * INVARIANTES
 *
 * 1) Una linea de obsequio nuestra lleva la propiedad _sio_regalo, para poder
 *    reconocerla aunque la promocion se desactive o se borre. Por eso el script
 *    NO se sale cuando no hay reglas: sigue corriendo para poder retirarlas.
 *
 * 2) UN OBSEQUIO NUNCA QUEDA COBRADO. Se le da una gracia tras agregarlo, porque
 *    el descuento del servidor tarda un instante; vencida la gracia, si sigue
 *    cobrado se retira. Hay UNA sola gracia y todo el archivo la respeta: una
 *    verificacion mas impaciente que la gracia retira obsequios que el servidor
 *    todavia estaba por poner en cero.
 *
 * 3) NINGUN OBSEQUIO CUENTA PARA UN UMBRAL. Ni gratis ni cobrado. Un obsequio
 *    cobrado que sumara al subtotal se pagaba su propio umbral y no se iba mas.
 *
 * 4) NUNCA SE BORRA UNA LINEA QUE NO CREAMOS. Si el cliente compro el mismo
 *    producto del obsequio, esa linea es suya. Se deja, no cuenta para umbrales,
 *    y si corresponde un obsequio se agrega en una linea aparte.
 *
 * 5) UN OBSEQUIO SIN INVENTARIO EN LA SUCURSAL NO SE AGREGA. Bloquearia el
 *    checkout por un producto que puso el sistema, no el cliente. Pero solo
 *    cuenta como agotado lo que el inventario RESPONDIO: si no se pudo preguntar,
 *    no se agrega en esta pasada y no se recuerda, porque un tropiezo de red no
 *    puede condenar el obsequio para el resto de la visita.
 *
 * 6) EL FRENO CUENTA INTENTOS QUE NO SALIERON BIEN, Y LO BORRA EL EXITO. Se cuenta
 *    cada alta; el contador vuelve a cero en cuanto el obsequio queda confirmado
 *    en cero. Asi cruzar el umbral, bajar y volver a cruzarlo se puede repetir sin
 *    limite —cada vuelta buena limpia la cuenta— y en cambio lo que no funciona
 *    se corta a los pocos intentos, ya sea porque el servidor se empena en cobrar
 *    el obsequio o porque la propia peticion de alta esta fallando.
 *
 *    Contar SOLO los cobros del servidor fue un error: si el alta misma falla, la
 *    linea nunca aparece, la verificacion nunca corre y no se incrementa nada, asi
 *    que se reintenta para siempre. Eso llego a dejar la tienda devolviendo 429.
 * ========================================================================== */
(function () {
  "use strict";

  var GIFT_PROP = "_sio_regalo";
  var GRACIA_MS = 2000;     // UNICA ventana en la que un obsequio cobrado no se juzga
  var MAX_REINTENTOS = 3;   // tope de intentos fallidos por variante y por pagina
  var ESPERA_MS = 350;      // agrupa varios cambios seguidos en una sola pasada
  var PAUSA_MS = 300000;    // silencio total tras un 429 o un 5xx de la tienda
  var CLAVE_PAUSA = "sio_gift_pausa";
  var INVENTARIO_URL = "https://sioconn.dislicores.com/poligonos/inventory";

  var rules = [];
  if (window.__sioGiftInit) return;
  window.__sioGiftInit = true;

  var busy = false;
  var pendiente = false;
  var timer = null;
  var fallos = {};          // variante -> intentos que no acabaron en obsequio gratis
  var agregadoEn = {};      // variante -> ultima vez que la agregamos
  var stockCache = {};      // "sucursal:producto" -> hay existencias
  var ultimaSucursal = null; // ultima sucursal conocida, para revisar badges nuevos

  // Variantes y productos que son obsequio de alguna regla. Se usa para no contar
  // NINGUNA de esas lineas en los umbrales (invariante 3).
  var variantesPremio = {};
  var productoDeVariante = {};

  /**
   * Las reglas NO se leen al cargar el archivo. El badge de la ficha sale de
   * Liquid (shop.metafields.sio.gift_rules); el auto-agregado lee
   * window.SIO_GIFT_RULES, que el tema pinta en un script mas abajo, o el
   * JSON #sio-gift-rules del embed. Si se capturaban aqui, el script se
   * quedaba con [] para siempre: etiqueta visible, carrito sin obsequio.
   */
  function leerReglas() {
    var fromWindow = window.SIO_GIFT_RULES;
    if (Array.isArray(fromWindow) && fromWindow.length) return fromWindow;
    try {
      var el = document.getElementById && document.getElementById("sio-gift-rules");
      if (el && el.textContent) {
        var v = JSON.parse(el.textContent);
        if (Array.isArray(v) && v.length) return v;
      }
    } catch (e) {}
    return Array.isArray(fromWindow) ? fromWindow : [];
  }

  function aplicarReglas(list) {
    rules = Array.isArray(list) ? list : [];
    variantesPremio = {};
    productoDeVariante = {};
    rules.forEach(function (r) {
      if (!r || !r.giftVariantId) return;
      var vid = String(r.giftVariantId);
      variantesPremio[vid] = true;
      if (r.giftProductId) productoDeVariante[vid] = String(r.giftProductId).split("/").pop();
    });
    return rules;
  }

  /* ---------------------------------------------------------------- utilidades */

  function getCart() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); });
  }

  /**
   * Agrega la linea del obsequio. Si la tienda responde mal —429 por exceso de
   * peticiones, 5xx, lo que sea— se anula la pasada pendiente: insistir contra una
   * tienda que ya esta diciendo que no solo empeora las cosas, y fue asi como este
   * script llego a dejar el carrito inutilizable.
   */
  function addGift(vid, qty) {
    var props = {};
    props[GIFT_PROP] = "1";
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: Number(vid), quantity: qty, properties: props }] }),
    }).then(function (r) {
      if (!r.ok) {
        fallos[vid] = MAX_REINTENTOS;
        if (pideParar(r)) pausar();
      }
      return r;
    });
  }

  function setQty(key, qty) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: String(key), quantity: qty }),
    }).then(function (r) {
      if (pideParar(r)) pausar();
      return r;
    });
  }

  function wait(ms) {
    return new Promise(function (res) { setTimeout(res, ms); });
  }

  /**
   * Freno de emergencia, y va en sessionStorage a proposito.
   *
   * Cuando la tienda responde 429 (demasiadas peticiones) o 5xx, lo que toca es
   * callarse un rato. El freno por variante vive en memoria y se pierde al recargar,
   * asi que sin esto cada recarga volvia a intentar el alta y mantenia viva la
   * limitacion: el cliente se quedaba con un carrito que no podia ni vaciar, porque
   * hasta el boton de borrar recibia 429.
   *
   * Sobrevive a las recargas y se olvida al cerrar la pestana, que es exactamente
   * la duracion que tiene sentido para algo asi.
   */
  function pausado() {
    try {
      var t = Number(sessionStorage.getItem(CLAVE_PAUSA) || 0);
      return t > 0 && (Date.now() - t) < PAUSA_MS;
    } catch (e) { return false; }
  }

  function pausar() {
    pendiente = false;
    try { sessionStorage.setItem(CLAVE_PAUSA, String(Date.now())); } catch (e) {}
  }

  /** ¿La tienda esta pidiendo que paremos? 429 y 5xx son exactamente eso. */
  function pideParar(r) {
    return !!r && (r.status === 429 || r.status >= 500);
  }

  /** Linea marcada por nosotros. */
  function esMarcada(it) {
    return !!(it && it.properties && it.properties[GIFT_PROP]);
  }

  /** Precio que realmente se paga por la linea. Un obsequio gratis da 0. */
  function precioPagado(it) {
    return Number((it && it.final_line_price) || 0);
  }

  /**
   * Linea que nos pertenece, es decir que podemos retirar. Son las que marcamos,
   * y tambien las de una variante de obsequio que estan en CERO: solo nuestro
   * descuento las pone asi, asi que son nuestras aunque les falte la marca (por
   * ejemplo si quedaron de una version anterior del script).
   *
   * Una linea de variante de obsequio COBRADA y sin marca NO es nuestra: pudo
   * comprarla el cliente, y no se toca (invariante 4).
   */
  function esNuestra(it) {
    if (esMarcada(it)) return true;
    var vid = String(it && it.variant_id);
    return !!variantesPremio[vid] && precioPagado(it) === 0;
  }

  /**
   * Codigos de descuento puestos en el carrito, en minusculas.
   *
   * Shopify los expone en /cart.js como discount_codes incluso cuando todavia no
   * descuentan nada, con applicable:false. Eso es justo lo que hace posible el
   * obsequio por codigo: sin la linea del obsequio en el carrito la funcion no
   * puede emitir nada y el codigo se queda en applicable:false, y sin el codigo el
   * tema no sabria que hay que agregarla. Leyendo el codigo introducido se rompe
   * ese circulo: agregamos la linea, la funcion ya la encuentra y la pone en cero,
   * y el codigo pasa a aplicable.
   */
  function codigosDelCarrito(cart) {
    var out = {};
    var lista = (cart && cart.discount_codes) || [];
    for (var i = 0; i < lista.length; i++) {
      var c = lista[i] && lista[i].code;
      if (c) out[String(c).toLowerCase()] = true;
    }
    return out;
  }

  /** Toda linea de una variante de obsequio queda fuera de los umbrales. */
  function cuentaParaUmbral(it) {
    return !variantesPremio[String(it && it.variant_id)];
  }

  /* ------------------------------------------------- inventario por sucursal */

  function sucursalDe(cart) {
    var a = (cart && cart.attributes) || {};
    var fromCart = String(a.sucursal_id || "").split("/").pop();
    if (fromCart) return fromCart;
    try {
      var st = JSON.parse(localStorage.getItem("sucursal_store") || "{}");
      return String((st && st.id) || "").split("/").pop();
    } catch (e) { return ""; }
  }

  /** Misma regla que placeOk / DiscountPlaceScope: vacío = todas las tiendas. */
  function lugarOk(rule, cart) {
    var ids = Array.isArray(rule && rule.locationIds)
      ? rule.locationIds.map(function (x) { return String(x == null ? "" : x).replace(/\D/g, ""); }).filter(Boolean)
      : [];
    var zs = Array.isArray(rule && rule.zones)
      ? rule.zones.map(function (z) { return String(z).trim().toUpperCase(); }).filter(Boolean)
      : [];
    if (!ids.length && !zs.length) return true;
    var suc = sucursalDe(cart);
    var attrs = (cart && cart.attributes) || {};
    var zone = String(attrs._sio_zone || "").trim().toUpperCase();
    if (ids.length && suc && ids.indexOf(suc) !== -1) return true;
    if (zs.length && zone && zs.indexOf(zone) !== -1) return true;
    return false;
  }

  /**
   * Falla CERRADA: sin sucursal o sin respuesta del endpoint devuelve false y no
   * se agrega. No dar el obsequio es una molestia; dejar el checkout bloqueado
   * por un producto agotado que puso el sistema es una venta perdida.
   */
  function tieneStock(loc, pid) {
    if (!loc || !pid) return Promise.resolve(false);
    var clave = loc + ":" + pid;
    if (Object.prototype.hasOwnProperty.call(stockCache, clave)) {
      return Promise.resolve(stockCache[clave]);
    }
    return fetch(INVENTARIO_URL + "?locationId=" + encodeURIComponent(loc) + "&productIds=" + encodeURIComponent(pid))
      .then(function (r) { if (!r.ok) throw new Error("inventario"); return r.json(); })
      .then(function (lista) {
        var hay = false;
        (Array.isArray(lista) ? lista : []).forEach(function (p) {
          var vs = Array.isArray(p && p.variants) ? p.variants : [];
          for (var i = 0; i < vs.length; i++) {
            if (Number(vs[i] && vs[i].available) > 0) { hay = true; break; }
          }
        });
        stockCache[clave] = hay;
        return hay;
      })
      // Si el inventario no responde, el badge se queda: un 500 no es "agotado".
      .catch(function () { return true; });
  }

  /* --------------------------------------------------------------- interfaz */

  /**
   * Repinta el carrito con el mecanismo NATIVO del tema, el mismo que este usa
   * despues de cada mutacion suya.
   *
   * Por que importa: los botones de cantidad del tema identifican las lineas por
   * su POSICION (updateQuantity(line, ...) en assets/cart.js). Si nosotros
   * agregamos o quitamos una linea y la vista no se vuelve a pintar, sus botones
   * apuntan a posiciones que ya no existen: el boton toca otra linea de la que
   * muestra y Shopify responde "El parametro line no es valido". Repintar tras
   * cada cambio estructural no es cosmetico, es lo que mantiene coherente al
   * carrito.
   *
   * El camino correcto son tres pasos, copiados de CartItems.updateQuantity:
   *
   *   1. Preguntar que secciones hay que renderizar. Cada componente de carrito
   *      presente en la pagina responde al evento "cart:grouped-sections"
   *      empujando su id: el cajon (cart-drawer) y la pagina (main-cart).
   *   2. Pedirlas por GET a la API de secciones, y el carrito por /cart.js.
   *   3. Publicar "cartUpdate". CartItems.onCartUpdate reemplaza el contenido de
   *      #CartDrawer-<seccion> y de #MainCart-<seccion>, asi que sirve a las dos
   *      superficies de una vez.
   *
   * Antes se despachaba "cart:refresh", que funcionaba en el cajon y por eso
   * parecia suficiente. Pero ese evento SOLO lo escucha CartDrawer
   * (assets/cart.js:21): en /cart no lo escucha nadie, y ahi seguian apareciendo
   * el obsequio cobrado, el conteo que se devuelve y el error de la linea.
   *
   * Y despues se hizo con un POST a /cart/update.js con updates vacio, que devuelve
   * las secciones ya renderizadas. Funciona, pero es una ESCRITURA sobre el carrito
   * para algo que solo tiene que leer, y este carrito lleva ahora estado que no es
   * de las lineas: el codigo de descuento que el cliente escribio. Refrescar no
   * puede arriesgarse a tocarlo. Por eso se pide por GET, que es ademas lo que hace
   * el propio tema en onCartRefresh.
   *
   * La peticion va por el fetch ORIGINAL a proposito. El nuestro esta interceptado
   * para reaccionar a las escrituras del carrito, y refrescar no es una escritura:
   * pasar por el gancho encolaria otra pasada de conciliacion por cada repintado.
   *
   * Si algo falta (tema sin FoxTheme, ninguna seccion declarada) se recurre a
   * "cart:refresh", que al menos cubre el cajon.
   */
  function refrescarCarrito() {
    function respaldo() {
      try { document.dispatchEvent(new CustomEvent("cart:refresh")); } catch (e) {}
    }
    try {
      var pubsub = window.FoxTheme && window.FoxTheme.pubsub;
      if (!pubsub || !pubsub.PUB_SUB_EVENTS || !pubsub.PUB_SUB_EVENTS.cartUpdate) return respaldo();

      var secciones = [];
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:grouped-sections", { bubbles: true, detail: { sections: secciones } })
      );
      if (!secciones.length) return respaldo();

      var rutas = window.FoxTheme.routes || {};
      var raiz = rutas.root_url || "/";
      if (raiz.charAt(raiz.length - 1) !== "/") raiz += "/";
      var carritoUrl = (rutas.cart_url || "/cart") + ".js";
      var pedir = fetchAnterior || window.fetch;
      var comoJson = { headers: { Accept: "application/json" } };

      Promise.all([
        pedir(raiz + "?sections=" + encodeURIComponent(secciones.join(",")), comoJson).then(function (r) { return r.json(); }),
        pedir(carritoUrl, comoJson).then(function (r) { return r.json(); }),
      ])
        .then(function (res) {
          var secciones = res[0], carrito = res[1];
          if (!carrito || !secciones) return respaldo();
          carrito.sections = secciones;
          pubsub.publish(pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: carrito });
        })
        .catch(respaldo);
    } catch (e) {
      respaldo();
    }
  }

  /**
   * Retira el badge de un obsequio agotado en la sucursal.
   *
   * Se puede llamar sin sucursal: entonces usa la ultima conocida. Hace falta
   * porque las superficies que pintan tarjetas despues de cargar la pagina —la
   * busqueda predictiva, sobre todo— no tienen de donde sacarla, y sin esto sus
   * badges nunca se revisaban: la vitrina escondia el obsequio agotado y el
   * desplegable de busqueda lo seguia anunciando.
   */
  function revisarBadges(loc) {
    if (loc) ultimaSucursal = loc; else loc = ultimaSucursal;
    var els = document.querySelectorAll("[data-sio-gift-pid]:not([hidden])");
    if (!els.length || !loc) return;
    var pids = {};
    for (var i = 0; i < els.length; i++) {
      var pid = String(els[i].getAttribute("data-sio-gift-pid") || "").split("/").pop();
      if (pid) pids[pid] = true;
    }
    Object.keys(pids).forEach(function (pid) {
      tieneStock(loc, pid).then(function (hay) {
        if (hay) return;
        for (var j = 0; j < els.length; j++) {
          if (String(els[j].getAttribute("data-sio-gift-pid") || "").split("/").pop() === pid) {
            els[j].hidden = true;
          }
        }
      });
    });
  }

  /* ----------------------------------------------------- cuanto obsequio va */

  /** Cantidad deseada por variante de obsequio, sumando todas las reglas. */
  function calcularDeseado(items, cart) {
    aplicarReglas(leerReglas());
    var codigos = codigosDelCarrito(cart);
    // Subtotal para umbrales: lo que el cliente paga, sin ninguna linea de
    // obsequio (invariante 3). Se usa el precio pagado, asi que un producto con
    // descuento cuenta por lo que cuesta de verdad.
    var subtotal = 0;
    items.forEach(function (it) {
      if (!cuentaParaUmbral(it)) return;
      subtotal += precioPagado(it);
    });
    subtotal = subtotal / 100;

    var deseado = {};

    rules.forEach(function (rule) {
      if (!rule || !rule.giftVariantId) return;
      // Regla atada a un codigo: no cuenta mientras el cliente no lo haya puesto.
      if (rule.codigo && !codigos[String(rule.codigo).toLowerCase()]) return;
      if (!lugarOk(rule, cart)) return;
      var giftVid = String(rule.giftVariantId);
      var ratio = Number(rule.ratio) || 1;

      var minCarrito = Number(rule.giftMinCart) || 0;
      if (minCarrito > 0) {
        deseado[giftVid] = (deseado[giftVid] || 0) + (subtotal >= minCarrito ? 1 : 0);
        return;
      }

      var porId = (rule.triggers || []).map(String);
      var porIdY = (rule.triggersY || []).map(String);
      var marcas = (rule.vendors || []).map(function (v) { return String(v).toLowerCase(); });
      var tipos = (rule.productTypes || []).map(function (v) { return String(v).toLowerCase(); });
      var minUnidades = Number(rule.minUnits) || 0;

      // Cuenta unidades disparadoras por id, marca o categoria. /cart.js trae
      // vendor y product_type, asi que una regla por marca no necesita listar
      // los productos. Ningun obsequio dispara otro obsequio.
      function contar(ids, usarMarcaYTipo) {
        var n = 0;
        items.forEach(function (it) {
          if (!cuentaParaUmbral(it)) return;
          var pid = String(it.product_id);
          var ven = String(it.vendor || "").toLowerCase();
          var typ = String(it.product_type || "").toLowerCase();
          var hit = ids.indexOf(pid) !== -1
            || (usarMarcaYTipo && (marcas.indexOf(ven) !== -1 || tipos.indexOf(typ) !== -1));
          if (hit) n += (it.quantity || 0);
        });
        return n;
      }

      var n = contar(porId, true);

      if (porIdY.length) {
        deseado[giftVid] = (deseado[giftVid] || 0) + Math.min(n, contar(porIdY, false)) * ratio;
        return;
      }
      if (minUnidades > 0) {
        deseado[giftVid] = (deseado[giftVid] || 0) + Math.floor(n / minUnidades) * ratio;
        return;
      }
      deseado[giftVid] = (deseado[giftVid] || 0) + n * ratio;
    });

    return deseado;
  }

  /* ------------------------------------------------------------ conciliacion */

  function conciliar() {
    // Si la tienda nos pidio parar, no se toca el carrito. Ni siquiera se lee: el
    // objetivo es dejar de sumar peticiones para que la limitacion expire y el
    // cliente recupere su carrito.
    if (pausado()) return Promise.resolve();
    if (busy) { pendiente = true; return Promise.resolve(); }
    busy = true;
    var agrego = false;

    return getCart()
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        var loc = sucursalDe(cart);
        revisarBadges(loc);

        var deseado = calcularDeseado(items, cart);

        // Nuestras lineas actuales, por variante. Solo las que nos pertenecen.
        var mias = {};
        items.forEach(function (it) {
          if (!esNuestra(it)) return;
          var vid = String(it.variant_id);
          // Preferir la marcada si hubiera varias
          if (!mias[vid] || (esMarcada(it) && !esMarcada(mias[vid]))) mias[vid] = it;
          if (!Object.prototype.hasOwnProperty.call(deseado, vid)) deseado[vid] = 0;
        });

        // Autoridad del servidor: una linea nuestra que NO esta en cero se retira,
        // aunque la estimacion diga que corresponde. Solo se respeta una gracia
        // corta tras agregarla, porque el descuento tarda un instante en aplicarse.
        Object.keys(mias).forEach(function (vid) {
          if (precioPagado(mias[vid]) === 0) return;
          var enGracia = (Date.now() - (agregadoEn[vid] || 0)) < GRACIA_MS;
          if (!enGracia) deseado[vid] = 0;
        });

        var vids = Object.keys(deseado);
        if (!vids.length) return false;

        // Inventario en la sucursal, solo de lo que habria que agregar.
        var porAgregar = vids.filter(function (vid) { return deseado[vid] > 0 && !mias[vid]; });

        return Promise.all(porAgregar.map(function (vid) {
          return tieneStock(loc, productoDeVariante[vid]).then(function (hay) {
            if (!hay) deseado[vid] = 0;
          });
        })).then(function () {
          var cadena = Promise.resolve();
          var cambio = false;

          vids.forEach(function (vid) {
            var quiero = deseado[vid];
            var linea = mias[vid] || null;
            var tengo = linea ? linea.quantity : 0;
            if (tengo === quiero) return;

            if (quiero > 0 && !linea) {
              // Se cuenta el intento ANTES de hacerlo (invariante 6). El exito lo
              // borra despues, en la verificacion. Contar solo los cobros del
              // servidor dejaba sin freno el caso en que falla el alta misma.
              if ((fallos[vid] || 0) >= MAX_REINTENTOS) return;
              fallos[vid] = (fallos[vid] || 0) + 1;
              agregadoEn[vid] = Date.now();
              agrego = true;
              cambio = true;
              cadena = cadena.then(function () { return addGift(vid, quiero); });
              return;
            }
            if (linea) {
              cambio = true;
              cadena = cadena.then(function () { return setQty(linea.key, quiero); });
            }
          });

          return cadena.then(function () { return cambio; });
        });
      })
      .then(function (cambio) {
        // Se pinta ya, sin esperar la verificacion, para que el cliente no vea el
        // carrito sin el obsequio durante casi un segundo.
        if (cambio) refrescarCarrito();
        if (!agrego) return cambio;

        // Verificacion: lo que acabamos de agregar tiene que haber quedado en cero.
        // Se espera a que VENZA LA GRACIA antes de juzgar. Antes esperaba menos que
        // la gracia del cuerpo principal, asi que retiraba obsequios que el servidor
        // aun estaba por poner gratis; la pasada siguiente los volvia a agregar y el
        // vaiven se comia el cupo de reintentos sin que nada estuviera realmente mal.
        return wait(GRACIA_MS)
          .then(getCart)
          .then(function (cart2) {
            var items = (cart2 && cart2.items) || [];
            var cadena = Promise.resolve();
            var corrigio = false;
            items.forEach(function (it) {
              if (!esMarcada(it)) return;
              var vid = String(it.variant_id);
              if (precioPagado(it) === 0) {
                // El servidor cumplio: se borra el historial de fallos para que los
                // proximos ciclos del cliente partan de cero (invariante 6).
                fallos[vid] = 0;
                return;
              }
              // Vencida la gracia sigue cobrado: se retira. No hace falta sumar
              // nada, el intento ya se conto al darlo de alta.
              corrigio = true;
              cadena = cadena.then(function () { return setQty(it.key, 0); });
            });
            return cadena.then(function () {
              if (corrigio) refrescarCarrito();
              return cambio || corrigio;
            });
          })
          .catch(function () { return cambio; });
      })
      .then(function () {
        busy = false;
        // Si algo cambio el carrito mientras trabajabamos, se repasa. Pasa por la
        // misma espera para que varias mutaciones seguidas se colapsen en una.
        if (pendiente) { pendiente = false; agendar(); }
      })
      .catch(function () { busy = false; pendiente = false; });
  }

  /**
   * Agenda una pasada. Si ya hay una agendada NO la reprograma: el tema tiene otro
   * script que agrega la bolsa y tambien escribe en el carrito, y reprogramar con
   * cada escritura hacia que los dos se dispararan en cascada.
   */
  function agendar() {
    if (timer) return;
    timer = setTimeout(function () {
      timer = null;
      conciliar();
    }, ESPERA_MS);
  }

  /* ------------------------------------------------------------- disparadores */

  var fetchAnterior = window.fetch;
  window.fetch = function (input) {
    var url = "";
    try { url = typeof input === "string" ? input : (input && input.url) || ""; } catch (e) {}
    var p = fetchAnterior.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
      return p.then(function (resp) { agendar(); return resp; });
    }
    return p;
  };

  /**
   * Las tarjetas que aparecen despues de cargar la pagina (busqueda predictiva,
   * paginacion infinita, filtros) traen sus badges sin revisar. Se vigila el
   * documento y, cuando entra alguno nuevo, se repasa con la sucursal conocida.
   * El repaso esta agrupado porque estas superficies insertan muchos nodos de
   * golpe, y es barato: tieneStock cachea por sucursal y producto.
   */
  if (window.MutationObserver) {
    var repaso = null;
    new MutationObserver(function (cambios) {
      if (repaso) return;
      var hayNuevos = false;
      for (var i = 0; i < cambios.length && !hayNuevos; i++) {
        var nodos = cambios[i].addedNodes || [];
        for (var j = 0; j < nodos.length; j++) {
          var n = nodos[j];
          if (n.nodeType !== 1) continue;
          if (n.matches && n.matches("[data-sio-gift-pid]")) { hayNuevos = true; break; }
          if (n.querySelector && n.querySelector("[data-sio-gift-pid]")) { hayNuevos = true; break; }
        }
      }
      if (!hayNuevos) return;
      repaso = setTimeout(function () { repaso = null; revisarBadges(null); }, 200);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { conciliar(); });
  } else {
    conciliar();
  }
})();
